import React, { useState, useEffect } from "react";
import BonusCard from "./BonusCard";
import MultipleBonusDialog from "./MultipleBonusDialog";
import { useBonus } from "../context/BonusContext";
import { useStatic } from "../context/StaticContext";

const BonusGrid = () => {
  const { bonusData, loading, gamesData, gamesLoading } = useBonus();
  const { activeTabs, setSelectedBonus, activeMainCategory } = useStatic();
  const [filteredBonuses, setFilteredBonuses] = useState([]);
  const [multipleBonusDialog, setMultipleBonusDialog] = useState({
    isOpen: false,
    bonuses: [],
  });

  // Aktif ana kategoriye göre kullanılacak veri ve loading durumunu belirle
  const currentData = activeMainCategory === "oyunlar" ? gamesData : bonusData;
  const currentLoading = activeMainCategory === "oyunlar" ? gamesLoading : loading;

  // Metin normalizasyon fonksiyonu
  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/ü/g, "u")
      .replace(/ı/g, "i")
      .replace(/ö/g, "o")
      .replace(/ğ/g, "g")
      .replace(/ş/g, "s")
      .replace(/ç/g, "c");
  };

  // currentData veya activeTabs değiştiğinde filtreleme yap
  useEffect(() => {
    if (!currentData || currentData.length === 0) {
      setFilteredBonuses([]);
      return;
    }

    // Kategoriları gruplandır (aynı görsel ve tip = çoklu seçenek)
    let groupedItems = [];
    currentData.forEach((category) => {
              if (category.data && Array.isArray(category.data)) {
          // Eğer bir kategoride birden fazla seçenek varsa, bu çoklu seçenek demektir
          if (category.data.length > 1) {
            // Çoklu seçenek için tek bir kart oluştur
            groupedItems.push({
              bonus_name: `${category.data[0].bonus_name} (${category.data.length} seçenek)`,
              process_name: `multiple_${category.data[0].process_name}`,
              bonus_type: category.bonus_type,
              bonus_gorsel: category.bonus_gorsel,
              kurallar: category.data[0].kurallar || [],
              is_bakim: category.data.some((item) => item.is_bakim),
              isMultiple: true,
              multipleOptions: category.data,
              redirect_link: category.data[0].redirect_link || null,
              talep_text: category.data[0].talep_text || null,
            });
          } else {
            // Tek seçenek için normal kart oluştur
            category.data.forEach((item) => {
              groupedItems.push({
                ...item,
                bonus_type: category.bonus_type,
                bonus_gorsel: category.bonus_gorsel,
                isMultiple: false,
              });
            });
          }
        }
      });

      if (activeTabs.includes("tumu")) {
        setFilteredBonuses(groupedItems);
      } else {
        // Tüm aktif sekmeleri normalize et
        const normalizedActiveTabs = activeTabs.map((tab) => normalizeText(tab));

        setFilteredBonuses(
          groupedItems.filter((item) => {
            // item_type string'ini array'e çevir ve normalize et
            const itemTypes = item.bonus_type
              .split(",")
              .map((type) => normalizeText(type));

            // Herhangi bir aktif tab bu item için geçerli mi kontrol et
            return itemTypes.some((type) => normalizedActiveTabs.includes(type));
          })
        );
      }
    }, [currentData, activeTabs]);

  // Çoklu bonus seçimi fonksiyonları
  const handleMultipleBonusRequest = (bonuses) => {
    setMultipleBonusDialog({
      isOpen: true,
      bonuses: bonuses,
    });
  };

  const handleCloseMultipleBonusDialog = () => {
    setMultipleBonusDialog({
      isOpen: false,
      bonuses: [],
    });
  };

  const handleBonusSelect = (selectedBonus) => {
    setSelectedBonus({
      bonus: selectedBonus,
    });
  };

  if (currentLoading) {
    return <div className="bonus-grid-loading">
      {activeMainCategory === "oyunlar" ? "Oyunlar yükleniyor..." : "Bonuslar yükleniyor..."}
    </div>;
  }

  return (
    <>
      <div className="bonus-grid">
        {filteredBonuses.map((bonus, index) => (
          <BonusCard
            key={`${bonus.process_name}-${index}-${bonus.bonus_name}`}
            title={bonus.bonus_name}
            imagePath={bonus.bonus_gorsel}
            processName={bonus.process_name}
            isMaintenance={bonus.is_bakim}
            rules={bonus.kurallar || []}
            isMultiple={bonus.isMultiple}
            multipleOptions={bonus.multipleOptions}
            redirectLink={bonus.redirect_link}
            confirmText={bonus.talep_text}
            onMultipleBonusRequest={handleMultipleBonusRequest}
          />
        ))}
      </div>

      <MultipleBonusDialog
        isOpen={multipleBonusDialog.isOpen}
        onClose={handleCloseMultipleBonusDialog}
        bonuses={multipleBonusDialog.bonuses}
        onBonusSelect={handleBonusSelect}
      />
    </>
  );
};

export default BonusGrid;
